import React, { useEffect } from 'react';
import './statistic.css';
import Header from "../../components/Header/Header";
import { useSelector, useDispatch } from "react-redux";
import { getStatisticSagaAction } from "../../redux/sagaActions";
import StatisticHeader from "../../components/PagesHeaders/StatisticHeader/StatisticHeader";

const Statistic = () => {
    const dispatch = useDispatch();
    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const statistic = useSelector(state => state.statistic);

    useEffect(() => {
        if (!currentEstablishment) return;
        // Получение статистики
        dispatch(getStatisticSagaAction());
    }, [currentEstablishment]);

    return (
        <>
            <Header component={ <StatisticHeader/> } />
            <div className="page">
                <div className="statistic">

                    <div className="statistic__box-wrapper">
                        {/* Продажи */}
                        <div className="statistic__box">
                            <div className="statistic__caption">Продажи</div>
                            <div className="table statistic__table">
                                <div className="table__row table__row--header table__row--statistic-3">
                                    <div className="table__cell table__cell--left">Название</div>
                                    <div className="table__cell">Количество</div>
                                    <div className="table__cell">Сумма</div>
                                </div>
                                {
                                    statistic?.payments?.map((elem, index) => {
                                        return (
                                            <div className="table__row table__row--hover table__row--statistic-3" key={ index }>
                                                <div className="table__cell table__cell--left">{ elem.key }</div>
                                                <div className="table__cell">{ elem.count }</div>
                                                <div className="table__cell">{ elem.sum }</div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>

                        {/* Методы оплаты */}
                        <div className="statistic__box">
                            <div className="statistic__caption">Методы оплаты</div>
                            <div className="table statistic__table">
                                <div className="table__row table__row--header table__row--statistic-3">
                                    <div className="table__cell table__cell--left">Метод оплаты</div>
                                    <div className="table__cell">Количество</div>
                                    <div className="table__cell">Сумма</div>
                                </div>
                                {
                                    statistic?.payments_methods?.map((elem, index) => {
                                        return (
                                            <div className="table__row table__row--hover table__row--statistic-3" key={ index }>
                                                <div className="table__cell table__cell--left">{ elem.key }</div>
                                                <div className="table__cell">{ elem.count }</div>
                                                <div className="table__cell">{ elem.sum }</div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>

                    <div className="statistic__box-wrapper">
                        {/* Абонементы */}
                        <div className="statistic__box">
                            <div className="statistic__caption">Абонементы</div>
                            <div className="table statistic__table">
                                <div className="table__row table__row--header table__row--statistic-3">
                                    <div className="table__cell table__cell--left">Название</div>
                                    <div className="table__cell">Количество</div>
                                    <div className="table__cell">Сумма</div>
                                </div>
                                {
                                    statistic?.subscriptions?.map((elem, index) => {
                                        return (
                                            <div className="table__row table__row--hover table__row--statistic-3" key={ index }>
                                                <div className="table__cell table__cell--left">{ elem.key }</div>
                                                <div className="table__cell">{ elem.count }</div>
                                                <div className="table__cell">{ elem.sum }</div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>

                        {/* Тренировки */}
                        <div className="statistic__box">
                            <div className="statistic__caption">Тренировки</div>
                            <div className="table statistic__table">
                                <div className="table__row table__row--header table__row--statistic-3">
                                    <div className="table__cell table__cell--left">Название</div>
                                    <div className="table__cell">Количество</div>
                                    <div className="table__cell">Сумма</div>
                                </div>
                                {
                                    statistic?.workouts?.map((elem, index) => {
                                        return (
                                            <div className="table__row table__row--hover table__row--statistic-3" key={ index }>
                                                <div className="table__cell table__cell--left">{ elem.key }</div>
                                                <div className="table__cell">{ elem.count }</div>
                                                <div className="table__cell">{ elem.sum }</div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>

                    <div className="statistic__box-wrapper">
                        {/* Тренеры */}
                        <div className="statistic__box">
                            <div className="statistic__caption">Тренеры</div>
                            <div className="table statistic__table">
                                <div className="table__row table__row--header table__row--statistic-3">
                                    <div className="table__cell table__cell--left">Тренер</div>
                                    <div className="table__cell">Групповые</div>
                                    <div className="table__cell">Количество</div>
                                </div>
                                {
                                    statistic?.coaches?.map((elem, index) => {
                                        return (
                                            <div className="table__row table__row--hover table__row--statistic-3" key={ index }>
                                                <div className="table__cell table__cell--left">{ elem.key }</div>
                                                <div className="table__cell">{ elem.group }</div>
                                                <div className="table__cell">{ elem.count }</div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>

                        {/* Товары */}
                        <div className="statistic__box">
                            <div className="statistic__caption">Товары</div>
                            <div className="table statistic__table">
                                <div className="table__row table__row--header table__row--statistic-3">
                                    <div className="table__cell table__cell--left">Товар</div>
                                    <div className="table__cell">Количество</div>
                                    <div className="table__cell">Сумма</div>
                                </div>
                                {
                                    statistic?.goods?.map((elem, index) => {
                                        return (
                                            <div className="table__row table__row--hover table__row--statistic-3" key={ index }>
                                                <div className="table__cell table__cell--left">{ elem.key }</div>
                                                <div className="table__cell">{ elem.count }</div>
                                                <div className="table__cell">{ elem.sum }</div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>

                    <div className="statistic__box-wrapper">
                        { /* Дополнительно */ }
                        <div className="statistic__box">
                            <div className="statistic__caption">Дополнительно</div>
                            <div className="table">
                                <div className="table__row table__row--header table__row--statistic-4">
                                    <div className="table__cell table__cell--left">Показатель</div>
                                    <div className="table__cell">Количество</div>
                                </div>
                                {
                                    statistic?.additional?.map((elem, index) => {
                                        return (
                                            <div className="table__row table__row--hover table__row--statistic-4" key={ index }>
                                                <div className="table__cell table__cell--left">{ elem.key }</div>
                                                <div className="table__cell">{ elem.count }</div>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>

                        { /* Бонусы */ }
                        {
                            statistic?.gift_orders?.length > 0 &&
                            <div className="statistic__box">
                                <div className="statistic__caption">Бонусы</div>
                                <div className="table">
                                    <div className="table__row table__row--header table__row--statistic-4">
                                        <div className="table__cell table__cell--left">Название</div>
                                        <div className="table__cell">Количество</div>
                                    </div>
                                    {
                                        statistic?.gift_orders?.map((elem, index) => {
                                            return (
                                                <div className="table__row table__row--hover table__row--statistic-4" key={ index }>
                                                    <div className="table__cell table__cell--left">{ elem.name }</div>
                                                    <div className="table__cell">{ elem.count }</div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        }
                    </div>

                    <div className="statistic__box-wrapper">
                        { /* Количество тренировок по купленным абонементам */ }
                        {
                            statistic?.workouts_from_subscriptions?.length > 0 &&
                            <div className="statistic__box">
                                <div className="statistic__caption">Количество купленных тренировок</div>
                                <div className="table">
                                    <div className="table__row table__row--header table__row--statistic-4">
                                        <div className="table__cell table__cell--left">Тренировки</div>
                                        <div className="table__cell">Количество</div>
                                    </div>
                                    {
                                        statistic?.workouts_from_subscriptions?.map((elem, index) => {
                                            return (
                                                <div className="table__row table__row--hover table__row--statistic-4" key={ index }>
                                                    <div className="table__cell table__cell--left">{ elem.times }</div>
                                                    <div className="table__cell">{ elem.count }</div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        }

                        { /* Продажи абонементов к разным тренерам */ }
                        {
                            statistic?.coach_subscriptions && Object.keys(statistic?.coach_subscriptions)?.length > 0 &&
                            <div className="statistic__box">
                                <div className="statistic__caption">Абонементы к тренерам</div>
                                <div className="table">
                                    {
                                        Object.keys(statistic.coach_subscriptions).map((elem, index) => {
                                            let count = 0;
                                            let sum = 0;
                                            return (
                                                <div key={ index }>
                                                    <div className="table__row table__row--header table__row--statistic-3">
                                                        <div className="table__cell table__cell--left">{ elem }</div>
                                                        <div className="table__cell">{ 'Кол-во' }</div>
                                                        <div className="table__cell">{ 'Сумма' }</div>
                                                    </div>
                                                    {
                                                        Object.keys(statistic.coach_subscriptions[elem]).map((el, ind) => {
                                                            count += parseInt(statistic.coach_subscriptions[elem][el]?.count);
                                                            sum += parseFloat(statistic.coach_subscriptions[elem][el]?.sum);
                                                            return (
                                                                <div className="table__row table__row--statistic-3" key={ ind }>
                                                                    <div className="table__cell table__cell--left">{ el }</div>
                                                                    <div className="table__cell">{ statistic.coach_subscriptions[elem][el]?.count }</div>
                                                                    <div className="table__cell">{ statistic.coach_subscriptions[elem][el]?.sum }</div>
                                                                </div>
                                                            );
                                                        })
                                                    }
                                                    <div className="table__row table__row--statistic-3">
                                                        <div className="table__cell">Итого</div>
                                                        <div className="table__cell">{ count }</div>
                                                        <div className="table__cell">{ sum }</div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default Statistic;